import React, {Component} from 'react'
import classNames from 'classnames'
import ArticleListPreview from '../ArticleListPreview'
import ArticlesList, {ARTICLES_LIST_DIRECTION_VERTICAL} from '../ArticlesList/ArticlesList'
import {
  ARTICLE_PREVIEW_TYPE_FEATURED,
  ARTICLE_PREVIEW_TYPE_MINI
} from '../../constants/articles'

class FeaturedArticlesSection extends Component {
  getFeaturedArticle () {
    const {articles} = this.props
    return articles[0]
  }

  getAsideArticles () {
    const {articles} = this.props
    return articles.slice(1, 3)
  }

  render () {
    const {className} = this.props
    const featuredArticle = this.getFeaturedArticle()
    return (
      <div className={classNames([
        'FeaturedArticlesSection',
        className
      ])}>
        <div className='FeaturedArticlesSection__articles'>
          <div className='FeaturedArticlesSection__articles__featured' role='region' aria-label='featured article'>
            {
              featuredArticle && <ArticleListPreview article={featuredArticle}
                articlePreviewType={ARTICLE_PREVIEW_TYPE_FEATURED} />
            }
          </div>
          <div className='FeaturedArticlesSection__articles__list'>
            <ArticlesList articles={this.getAsideArticles()} articlePreviewType={ARTICLE_PREVIEW_TYPE_MINI}
              direction={ARTICLES_LIST_DIRECTION_VERTICAL} listOf={2} />
          </div>
        </div>
      </div>
    )
  }
}

FeaturedArticlesSection.defaultProps = {
  className: ''
}

export default FeaturedArticlesSection



// WEBPACK FOOTER //
// ./client/components/FeaturedArticlesSection/FeaturedArticlesSection.js